const resData=[
  
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "869093",
                        "name": "BAKENBROWN",
                        "city": "57",
                        "slugs": {
                          "restaurant": "bakenbrown-sahid-nagar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/10/0bb275d4-9f3e-4d15-ba8f-a9bc4b307bfb_869093.JPG",
                        "address": "Shop No : 738/3 , Floor :  , Ward 27 , Near SBI Bank , BAKENBROWN, Biju Pattnaik College Road, near Rath Arcade, Jayadev Vihar, Bhubaneswar, Odisha, India",
                        "locality": "Near SBI Bank",
                        "areaName": "Jaydev Vihar",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Bakery",
                          "Beverages",
                          "Snacks",
                          "Pizzas",
                          "Pastas",
                          "Burgers",
                          "Cafe"
                        ],
                        "avgRating": 4.3,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.3",
                        "totalRatingsString": "149",
                        "promoted": true,
                        "adTrackingId": "cid=22700977~p=0~adgrpid=22700977#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=869093~st=top rated pizza joints in bhubaneswar~eid=c82c4e92-1332-40e0-86d9-ffd17cbb233b~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 17,
                          "minDeliveryTime": 15,
                          "maxDeliveryTime": 20,
                          "lastMileTravel": 0.9,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "15-20 MINS",
                          "lastMileTravelString": "0.9 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹139",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22700977"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22700977~p=0~adgrpid=22700977#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=869093~st=top rated pizza joints in bhubaneswar~eid=c82c4e92-1332-40e0-86d9-ffd17cbb233b~srvts=1734359967397\"}",
                        "objectValue": "869093",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "869093",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "377102",
                        "name": "Mamma Mia - Mayfair Lagoon",
                        "city": "57",
                        "slugs": {
                          "restaurant": "mamma-mia-sahid-nagar-sahid-nagar-2",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "oteirqk3fmbzwdzztpjo",
                        "address": "8-B, Jaydev Vihar Bhubaneswar, Odisha 751013",
                        "locality": "Jayadev Vihar",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "150000",
                        "costForTwoMessage": "₹1500 FOR TWO",
                        "cuisines": [
                          "Continental"
                        ],
                        "avgRating": 4.9,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.9",
                        "totalRatingsString": "78",
                        "sla": {
                          "deliveryTime": 38,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 1,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "1.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.4",
                            "ratingCount": "367"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "377102",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "377102",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "559248",
                        "name": "Domino's Pizza",
                        "city": "57",
                        "slugs": {
                          "restaurant": "dominos-pizza-pal-heights-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/29/31c3b0a6-17ff-4afd-8c96-7b9a7aba1e51_559248.jpg",
                        "address": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha",
                        "locality": "Jayadev Vihar",
                        "areaName": "Saheed Nagar",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Pizzas",
                          "Italian",
                          "Pastas",
                          "Desserts"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "1.6K+",
                        "promoted": true,
                        "adTrackingId": "cid=22710502~p=1~adgrpid=22710502#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=559248~st=top rated pizza joints in bhubaneswar~eid=08bededa-73f8-4803-a866-3bd48efb4b4a~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 25,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 0.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "0.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Pizza.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "₹125 OFF",
                          "subHeader": "ABOVE ₹1199",
                          "discountTag": "FLAT DEAL",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22710502"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22710502~p=1~adgrpid=22710502#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=559248~st=top rated pizza joints in bhubaneswar~eid=08bededa-73f8-4803-a866-3bd48efb4b4a~srvts=1734359967397\"}",
                        "objectValue": "559248",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "559248",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "122348",
                        "name": "Bling It On-The New Marrion Hotel",
                        "city": "57",
                        "slugs": {
                          "restaurant": "bling-it-on-the-new-marrion-hotel-janpath-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "ek6ujsmnq6aqzxjryofu",
                        "address": "Hotel Marrion, 6, Janpath, Near Ram Mandir, Bhubaneswar, Kharabela Nagar, Bhubaneshwar",
                        "locality": "Kharabela Nager",
                        "areaName": "Kharabela Nagar",
                        "costForTwo": "70000",
                        "costForTwoMessage": "₹700 FOR TWO",
                        "cuisines": [
                          "Indian",
                          "Continental"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "557",
                        "sla": {
                          "deliveryTime": 44,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "5.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "newg.png",
                              "description": "Gourmet"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.1",
                            "ratingCount": "418"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "122348",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "122348",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "446796",
                        "name": "Faasos - Wraps, Rolls & Shawarma",
                        "city": "57",
                        "slugs": {
                          "restaurant": "faasos-patia-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/28/c12a8911-b94e-4e1a-b714-f767e6e5bd8c_446796.JPG",
                        "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                        "locality": "Technology Corridor Rd",
                        "areaName": "Patia",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Kebabs",
                          "Fast Food",
                          "Snacks",
                          "American",
                          "Healthy Food",
                          "Desserts",
                          "Beverages"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "3.1K+",
                        "promoted": true,
                        "adTrackingId": "cid=22688914~p=2~adgrpid=22688914#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446796~st=top rated pizza joints in bhubaneswar~eid=bc881584-a6c1-4483-9571-d0c6d23b920e~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 40,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 6.2,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "6.2 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "50% OFF",
                          "subHeader": "UPTO ₹100",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22688914"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22688914~p=2~adgrpid=22688914#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446796~st=top rated pizza joints in bhubaneswar~eid=bc881584-a6c1-4483-9571-d0c6d23b920e~srvts=1734359967397\"}",
                        "objectValue": "446796",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "446796",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "988657",
                        "name": "KRUTI COFFEE",
                        "city": "57",
                        "slugs": {
                          "restaurant": "kruti-coffee-sahid-nagar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/11/a64be4f5-c9fc-4470-8a2d-a690182659f6_988657.jpg",
                        "address": "Shop No : 01 , Floor :  , Pal Height , ",
                        "locality": "Sahid Nagar",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Cafe"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "12",
                        "sla": {
                          "deliveryTime": 26,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 0.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "0.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "20% OFF",
                          "subHeader": "UPTO ₹50",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "988657",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "988657",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "831931",
                        "name": "TEALOGY",
                        "city": "57",
                        "slugs": {
                          "restaurant": "tealogy-chandrashekarpur-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "330f7d11d515aad8269ab4e729e339e4",
                        "address": "SHOP NO. B6 , NALCO ROAD, OPPOSITE ODISHA STATE ARMED FORCE POLICE, 7TH BATTALION, SAMANTA VIHAR, CHANDRASEKHARPUR, Samanta Vihar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751017",
                        "locality": "Samanta Vihar",
                        "areaName": "Chandrashekarpur",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Beverages",
                          "Cafe"
                        ],
                        "avgRating": 4.1,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.1",
                        "totalRatingsString": "71",
                        "promoted": true,
                        "adTrackingId": "cid=22625158~p=3~adgrpid=22625158#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=831931~st=top rated pizza joints in bhubaneswar~eid=93e0e494-365b-449a-aede-642569c8aeb8~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 28,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 2.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "2.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "v1695133679/badges/Pure_Veg111.png",
                              "description": "pureveg"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹109",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22625158"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22625158~p=3~adgrpid=22625158#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=831931~st=top rated pizza joints in bhubaneswar~eid=93e0e494-365b-449a-aede-642569c8aeb8~srvts=1734359967397\"}",
                        "objectValue": "831931",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "831931",
                          "query": "Top Rated Pizza Joints In Bhubaneswar"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "985234",
                        "name": "Domino's Chicken Fiesta",
                        "city": "57",
                        "slugs": {
                          "restaurant": "dominos-chicken-fiesta-jayadev-vihar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/5/8cb3c18b-7d42-44f4-8aad-ea38a76c4c9b_985234.jpg",
                        "address": "First Floor, PAL Heights, J/7, Jayadev Vihar,Bhubaneswar 751013, Odisha",
                        "locality": "Jayadev Vihar",
                        "areaName": "Saheed Nagar",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Pizzas",
                          "Italian",
                          "Pastas",
                          "Desserts"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "6",
                        "sla": {
                          "deliveryTime": 25,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 0.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "0.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "30% OFF",
                          "subHeader": "UPTO ₹75",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "985234",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "985234"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "446800",
                        "name": "Oven Story Pizza - Standout Toppings",
                        "city": "57",
                        "slugs": {
                          "restaurant": "oven-story-pizza-patia-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/1/4f1dcc50-adb0-47fd-9135-b73cd15d17d7_446800.jpg",
                        "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                        "locality": "Technology Corridor Rd",
                        "areaName": "Patia",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Pizzas",
                          "Pastas",
                          "Italian",
                          "Desserts",
                          "Beverages"
                        ],
                        "avgRating": 4.4,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.4",
                        "totalRatingsString": "2.4K+",
                        "promoted": true,
                        "adTrackingId": "cid=22688921~p=4~adgrpid=22688921#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446800~st=top rated pizza joints in bhubaneswar~eid=0b541130-b491-4b9c-9344-167f9d5ec48a~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 43,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 6.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "6.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Pizza.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "50% OFF",
                          "subHeader": "UPTO ₹100",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22688921"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22688921~p=4~adgrpid=22688921#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=446800~st=top rated pizza joints in bhubaneswar~eid=0b541130-b491-4b9c-9344-167f9d5ec48a~srvts=1734359967397\"}",
                        "objectValue": "446800",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "446800",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "744844",
                        "name": "Burger King",
                        "city": "57",
                        "slugs": {
                          "restaurant": "burger-king-pal-heights-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/a5cee281-c25f-494a-8cab-ba7f49acfb03_744844.JPG",
                        "address": "Plot No-J-7, Ground & First Floor, Pal Heights,  Ward 16,Bhubaneswar Municipal Corporation ,Orissa,751013",
                        "locality": "Jayadev Vihar",
                        "areaName": "bhubaneswar",
                        "costForTwo": "35000",
                        "costForTwoMessage": "₹350 FOR TWO",
                        "cuisines": [
                          "Burgers",
                          "American"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "6.0K+",
                        "sla": {
                          "deliveryTime": 16,
                          "minDeliveryTime": 15,
                          "maxDeliveryTime": 20,
                          "lastMileTravel": 0.5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "15-20 MINS",
                          "lastMileTravelString": "0.5 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
                              "description": "bolt!"
                            },
                            {
                              "imageId": "Rxawards/_CATEGORY-Burger.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "60% OFF",
                          "subHeader": "UPTO ₹120",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.5",
                            "ratingCount": "821"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "744844",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "744844",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "621140",
                        "name": "McDonald's",
                        "city": "57",
                        "slugs": {
                          "restaurant": "mcdonalds-patia-patia",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/22/7d3e0c44-ce41-476a-826b-6799685eb3a0_621140.JPG",
                        "address": "GF-2 & FF-2, Plot No. G/51 corresponding to Revenue Plot No. 457/1952, Khata No.619, Mauza Chandresekkarpur, Bhubaneshwar, Odisha-751015",
                        "locality": "Chandresekkarpur",
                        "areaName": "Chandrasekharpur",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "American",
                          "Fast Food"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "8.4K+",
                        "promoted": true,
                        "adTrackingId": "cid=22710499~p=5~adgrpid=22710499#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=621140~st=top rated pizza joints in bhubaneswar~eid=52b0a251-4f0a-40b7-865d-e4862b3760ca~srvts=1734359967397",
                        "sla": {
                          "deliveryTime": 28,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 5.6,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "5.6 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Burger.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        },
                        "campaignId": "22710499"
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\",\"adTrackingId\":\"cid=22710499~p=5~adgrpid=22710499#ag1~mp=SWIGGY_IN~bl=FOOD~aet=RESTAURANT~aeid=621140~st=top rated pizza joints in bhubaneswar~eid=52b0a251-4f0a-40b7-865d-e4862b3760ca~srvts=1734359967397\"}",
                        "objectValue": "621140",
                        "impressionObjectName": "impression-restaurant-ad",
                        "clickObjectName": "click-restaurant-ad"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "621140",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "325757",
                        "name": "Mio Amore",
                        "city": "57",
                        "slugs": {
                          "restaurant": "mio-amore-sahid-nagar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "tywmcvle4g3fd4culvjr",
                        "address": "Plot- 8(P),Acharya Vihar Chawk,Bhubaneswar 751022",
                        "locality": "Mio Amore Acharya Vihar,Near Acharya Vihar Square",
                        "areaName": "Acharya Vihar",
                        "costForTwo": "15000",
                        "costForTwoMessage": "₹150 FOR TWO",
                        "cuisines": [
                          "Bakery",
                          "Desserts",
                          "Snacks",
                          "Confectionery"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "949",
                        "sla": {
                          "deliveryTime": 21,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 1.8,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "1.8 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Desserts.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "325757",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "325757",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "408185",
                        "name": "Pizza Hut",
                        "city": "57",
                        "slugs": {
                          "restaurant": "pizza-hut-jaydev-vihar-bbsr-patia",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/17/53d5f5b4-1e37-4855-8f11-aa5ef1d12d47_408185.jpg",
                        "address": "Pizza Hut, XIMB Square, Plot No-P-1 & P-1/A, Jayadev Vihar, Bhubaneswar, Khordha, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa, 751013",
                        "locality": "XIMB Square",
                        "areaName": "Jayadev Vihar",
                        "costForTwo": "30000",
                        "costForTwoMessage": "₹300 FOR TWO",
                        "cuisines": [
                          "Pizzas"
                        ],
                        "avgRating": 4.4,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.4",
                        "totalRatingsString": "6.0K+",
                        "sla": {
                          "deliveryTime": 22,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 1.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "1.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Pizza.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "50% OFF",
                          "subHeader": "UPTO ₹100",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "408185",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "408185",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "644648",
                        "name": "Chicago Delights",
                        "city": "57",
                        "slugs": {
                          "restaurant": "chicago-delights-nayapalli-nayapalli",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "ba127c795a238e210ea4d7792503260a",
                        "address": "Plot No-194/4793, Jayadev Vihar, Ekamra Kanan Road, Nayapally, Bolagad, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa - 751013",
                        "locality": "Jayadev Vihar",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Pizzas"
                        ],
                        "avgRating": 4.4,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.4",
                        "totalRatingsString": "36",
                        "sla": {
                          "deliveryTime": 28,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 1.5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "1.5 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹169",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "644648",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "644648",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "427907",
                        "name": "Indiana Burgers",
                        "city": "57",
                        "slugs": {
                          "restaurant": "indiana-burgers-sahid-nagar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "fqgpfqk8kpljczpjbkll",
                        "address": "Plot No 1482, Sastri Nagar, Unit-4, Near SBI Colony, PS Capital, Bhubaneswar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751001",
                        "locality": "Irc Village",
                        "areaName": "Unit 4",
                        "costForTwo": "15000",
                        "costForTwoMessage": "₹150 FOR TWO",
                        "cuisines": [
                          "Burgers",
                          "American",
                          "Fast Food",
                          "Beverages",
                          "Desserts"
                        ],
                        "avgRating": 4.3,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.3",
                        "totalRatingsString": "224",
                        "sla": {
                          "deliveryTime": 25,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 1.8,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "1.8 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "bolt/Bolt%20Listing%20badge@3x.png",
                              "description": "bolt!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹129",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "427907",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "427907",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "881320",
                        "name": "Taste With Dibyam",
                        "city": "57",
                        "slugs": {
                          "restaurant": "taste-with-dibyam-old-bbsr-old-bbsr",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/7/a49e808f-deaa-41d7-9688-5975344626f1_881320.jpg",
                        "address": "PLOT NO-2018/2005,3RD LANE ,Chintamaniswar Temple area,Ward 45,BHUBANESWAR MUNICIPAL CORPORATION,Orissa-751006",
                        "locality": "Back side of Chintamaniswar Temple",
                        "areaName": "Chintamaniswar City",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Fast Food",
                          "Cafe"
                        ],
                        "avgRating": 4.8,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.8",
                        "totalRatingsString": "14",
                        "sla": {
                          "deliveryTime": 45,
                          "minDeliveryTime": 45,
                          "maxDeliveryTime": 50,
                          "lastMileTravel": 7.2,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "45-50 MINS",
                          "lastMileTravelString": "7.2 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "v1695133679/badges/Pure_Veg111.png",
                              "description": "pureveg"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹79",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "881320",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "881320"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "78062",
                        "name": "Bocca Cafe",
                        "city": "57",
                        "slugs": {
                          "restaurant": "bocca-cafe-kharbela-nagar-nayapalli",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "ed20b1b021bf37689a603c024eb72fd3",
                        "address": "108/B, 1st Floor, Janpath Road, Master Canteen Area, Kharabela Nagar, Bhubaneshwar",
                        "locality": "Kharvela Nagar",
                        "areaName": "Kharvela Nagar",
                        "costForTwo": "50000",
                        "costForTwoMessage": "₹500 FOR TWO",
                        "cuisines": [
                          "Cafe",
                          "Italian",
                          "Healthy Food"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "2.0K+",
                        "sla": {
                          "deliveryTime": 39,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "5.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "newg.png",
                              "description": "Gourmet"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "FREE ITEM",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.3",
                            "ratingCount": "3.5K+"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "78062",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "78062"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "336263",
                        "name": "OBERAI BAKERS and CAFE",
                        "city": "57",
                        "slugs": {
                          "restaurant": "oberai-bakers-&-café-khandagiri-khandagiri",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "elnoyawchrptpvof2l1d",
                        "address": "Plot No: 1294, CRPF Square, Nayapalli, Bhubaneswar. ",
                        "locality": "Crpf Square",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Bakery",
                          "North Indian",
                          "Chinese",
                          "Continental",
                          "Tandoor"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "4.1K+",
                        "sla": {
                          "deliveryTime": 31,
                          "minDeliveryTime": 30,
                          "maxDeliveryTime": 35,
                          "lastMileTravel": 3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "30-35 MINS",
                          "lastMileTravelString": "3.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "336263",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "336263",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "860595",
                        "name": "Greenwheel Pizza",
                        "city": "57",
                        "slugs": {
                          "restaurant": "greenwheel-pizza-old-bbsr-old-bbsr-2",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "d9b5570d65d8600f10d985a817e0f0ff",
                        "address": "PLOT NO-110,FISHERY LANE, BUDHESWARI, Fishery Tank area,, Ward 43, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751006",
                        "locality": "Laxmisagar",
                        "areaName": "Old BBSR",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Continental",
                          "Mexican",
                          "Cafe"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "19",
                        "sla": {
                          "deliveryTime": 41,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 7.5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "7.5 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "860595",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "860595",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "191689",
                        "name": "Oberai Bakers & Cafe ",
                        "city": "57",
                        "slugs": {
                          "restaurant": "oberai-bakers-&-cafe-rasulgarh-rasulgarh",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "hykbeg6boj0xydptikrt",
                        "address": "6, Nh-203, Budheswari Colony, Laxmisagar, Bhubaneswar, Odisha 751006, India",
                        "locality": "Lakshmi Sagar",
                        "areaName": "Lakshmi Sagar",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Biryani",
                          "Chinese",
                          "North Indian",
                          "Bakery",
                          "Continental"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "25K+",
                        "sla": {
                          "deliveryTime": 38,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 6.5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "6.5 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "Rxawards/_CATEGORY-Desserts.png",
                              "description": "Delivery!"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.2",
                            "ratingCount": "2.6K+"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "191689",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "191689",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "468707",
                        "name": "Insta Food",
                        "city": "57",
                        "slugs": {
                          "restaurant": "insta-food-sahid-nagar-sahid-nagar",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "a1tk3kix54ksdmzxlaov",
                        "address": "Bomikhal Canal Road, GGP Colony, Bhubaneswar, Falcon Motors, Ward 33, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751007",
                        "locality": "GGP Colony",
                        "areaName": "Rasulgarh",
                        "costForTwo": "35000",
                        "costForTwoMessage": "₹350 FOR TWO",
                        "cuisines": [
                          "Chinese",
                          "Indian"
                        ],
                        "avgRating": 5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "5.0",
                        "totalRatingsString": "3",
                        "sla": {
                          "deliveryTime": 41,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 6.1,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "6.1 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "10% OFF",
                          "subHeader": "UPTO ₹40",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "468707",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "468707",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "496362",
                        "name": "Paris Bakery",
                        "city": "57",
                        "slugs": {
                          "restaurant": "paris-bakery-khandagiri-khandagiri-2",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "9bfaba19e65952b54795baa397e7f46b",
                        "address": "Plot No-10 P, CITY MART, BARMUNDA, BHUBANESWAR, Ward 50, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751003",
                        "locality": "Baramunda ,CRP, Sumhospital ,Khandagiri,Beside Domino's Pizza",
                        "areaName": "Baramunda",
                        "costForTwo": "15000",
                        "costForTwoMessage": "₹150 FOR TWO",
                        "cuisines": [
                          "Bakery"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "93",
                        "sla": {
                          "deliveryTime": 24,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 4.2,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "4.2 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          "imageBadges": [
                            {
                              "imageId": "v1695133679/badges/Pure_Veg111.png",
                              "description": "pureveg"
                            }
                          ]
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹489",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "496362",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "496362",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "157316",
                        "name": "Rolling Crunchys",
                        "city": "57",
                        "slugs": {
                          "restaurant": "rolling-kitchen-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "st6koojm2pzjzlivrtll",
                        "address": "Plot No-336, Saheed Nagar,Ps-Saheed Nagar, Bhubaneswar, Saheed Nagar Area., Ward 30, Bhubaneswar Municipal Corporation,Orissa-751007",
                        "locality": "Bhatar",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "39900",
                        "costForTwoMessage": "₹399 FOR TWO",
                        "cuisines": [
                          "Italian",
                          "Pizzas",
                          "Pastas",
                          "Beverages"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "1.9K+",
                        "sla": {
                          "deliveryTime": 32,
                          "minDeliveryTime": 30,
                          "maxDeliveryTime": 35,
                          "lastMileTravel": 4,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "30-35 MINS",
                          "lastMileTravelString": "4.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "30% OFF",
                          "subHeader": "UPTO ₹75",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.4",
                            "ratingCount": "449"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "157316",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "157316"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "716628",
                        "name": "Chicago Pizza",
                        "city": "57",
                        "slugs": {
                          "restaurant": "chicago-pizza-khandagiri-khandagiri",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "df9cda7c0c991be05cc5bb7dd9f13c42",
                        "address": "Ground Floor Plot No1199 2635 Soubhagya Nagar Baramunda Bhubaneswar Khordha Odisha 751003",
                        "locality": "Baramunda",
                        "areaName": "Baramunda",
                        "costForTwo": "50000",
                        "costForTwoMessage": "₹500 FOR TWO",
                        "cuisines": [
                          "Fast Food",
                          "Pizzas"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "794",
                        "sla": {
                          "deliveryTime": 41,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "5.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹119",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.3",
                            "ratingCount": "76"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "716628",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "716628",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "920670",
                        "name": "Big Cup Cafe & Restaurant",
                        "city": "57",
                        "slugs": {
                          "restaurant": "big-cup-cafe-&-restaurant-khandagiri-khandagiri",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/4/622103a6-68a0-440d-b667-267acab42e4b_920670.JPG",
                        "address": "Shop No : PLOTNO-1078/110 , Floor : 1 , BIG CUP CAFE, SAMPUR , ",
                        "locality": "SAMPUR",
                        "areaName": "Khandagiri",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Chinese",
                          "Pizzas",
                          "Burgers",
                          "Cafe"
                        ],
                        "avgRating": 4.7,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.7",
                        "totalRatingsString": "86",
                        "sla": {
                          "deliveryTime": 47,
                          "minDeliveryTime": 45,
                          "maxDeliveryTime": 50,
                          "lastMileTravel": 8.6,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "45-50 MINS",
                          "lastMileTravelString": "8.6 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "920670",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "920670"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "548185",
                        "name": "Biryani Badshah",
                        "city": "57",
                        "slugs": {
                          "restaurant": "biryani-badshah-patia-patia",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "meimzh3k9qvfdo2fe3vk",
                        "address": "HOUSE NO. 301, GROUND FLOOR, DISTRICT CENTER, CHANDRASEKHARPUR, BHUBANESWAR, , ward 9, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751016",
                        "areaName": "Chandrasekharpur",
                        "costForTwo": "35000",
                        "costForTwoMessage": "₹350 FOR TWO",
                        "cuisines": [
                          "Biryani",
                          "Hyderabadi",
                          "Andhra",
                          "South Indian",
                          "North Indian",
                          "Mughlai",
                          "Kebabs"
                        ],
                        "avgRating": 4.3,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.3",
                        "totalRatingsString": "2.7K+",
                        "sla": {
                          "deliveryTime": 25,
                          "minDeliveryTime": 20,
                          "maxDeliveryTime": 25,
                          "lastMileTravel": 3.8,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "20-25 MINS",
                          "lastMileTravelString": "3.8 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹179",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "548185",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "548185",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "973470",
                        "name": "Sakshata Cafe",
                        "city": "57",
                        "slugs": {
                          "restaurant": "sakshata-cafe-khandagiri-khandagiri",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/10/16/07353551-3e90-4b48-91a5-a2f8ed596546_973470.jpg",
                        "address": "Plot No-42,K7,Kalinga Nagar,Ghatikia,Khandagiri,Bhubaneswar, Kalinga Nagar, Ward 23, BHUBANESWAR MUNICIPAL CORPORATION, Orissa - 751003",
                        "locality": "Khandagiri",
                        "areaName": "Khandagiri",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Cafe"
                        ],
                        "avgRating": 5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "5.0",
                        "totalRatingsString": "4",
                        "sla": {
                          "deliveryTime": 48,
                          "minDeliveryTime": 45,
                          "maxDeliveryTime": 50,
                          "lastMileTravel": 9.9,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "45-50 MINS",
                          "lastMileTravelString": "9.9 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "₹250 OFF",
                          "subHeader": "ABOVE ₹999",
                          "discountTag": "FLAT DEAL",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "973470",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "973470",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "735621",
                        "name": "Bentoz Pizza",
                        "city": "57",
                        "slugs": {
                          "restaurant": "bentoz-pizza---by-warmoven-nayapalli-nayapalli",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "dd841f517c1071baef3aa697d9fe008a",
                        "address": "Plot No 1482, Sastri Nagar, Unit-4, Near SBI Colony, PS Capital, Bhubaneswar, Ward 12, BHUBANESWAR MUNICIPAL CORPORATION, Orissa-751001",
                        "locality": "Sastri nagar",
                        "areaName": "Sahid Nagar",
                        "costForTwo": "50000",
                        "costForTwoMessage": "₹500 FOR TWO",
                        "cuisines": [
                          "Pizzas",
                          "Desserts",
                          "Italian"
                        ],
                        "avgRating": 3.9,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "3.9",
                        "totalRatingsString": "9",
                        "sla": {
                          "deliveryTime": 27,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 1.8,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "1.8 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "40% OFF",
                          "subHeader": "UPTO ₹80",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_4",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "735621",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "735621",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "881905",
                        "name": "The Pizza Project by Oven Story",
                        "city": "57",
                        "slugs": {
                          "restaurant": "the-pizza-project-by-oven-story-technology-corridor-rd-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/8/824f24fd-1c73-4877-99e3-f85305434965_881905.jpg",
                        "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                        "locality": "Technology Corridor Rd",
                        "areaName": "Patia",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Pizzas",
                          "Italian",
                          "Desserts",
                          "Beverages"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "19",
                        "sla": {
                          "deliveryTime": 38,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 6.2,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "6.2 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "ITEMS",
                          "subHeader": "AT ₹89",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "881905",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "881905",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "566517",
                        "name": "Faasos' Signature Wraps & Rolls",
                        "city": "57",
                        "slugs": {
                          "restaurant": "signature-wraps-rolls-by-faasos-patia-chandrashekarpur",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                        "address": "17, Technology Corridor Rd, Infocity, Chandrasekharpur, Bhubaneswar, Odisha 751024",
                        "locality": "Technology Corridor Rd",
                        "areaName": "Patia",
                        "costForTwo": "35000",
                        "costForTwoMessage": "₹350 FOR TWO",
                        "cuisines": [
                          "Fast Food",
                          "Snacks",
                          "North Indian",
                          "Desserts",
                          "Beverages"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "379",
                        "sla": {
                          "deliveryTime": 37,
                          "minDeliveryTime": 35,
                          "maxDeliveryTime": 40,
                          "lastMileTravel": 6.2,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "35-40 MINS",
                          "lastMileTravelString": "6.2 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "50% OFF",
                          "subHeader": "UPTO ₹100",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "566517",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "566517"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "861589",
                        "name": "Pastas By Pizza Hut",
                        "city": "57",
                        "slugs": {
                          "restaurant": "pastas-by-pizza-hut-ximb-square-patia",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/3065f36b-6cfa-4940-8efa-ec0adfe970d3_861589.JPG",
                        "address": "Pizza Hut, XIMB Square, Plot No-P-1 & P-1/A, Jayadev Vihar, Bhubaneswar, Khordha, KHORDHA(EXCEPT MUNICIPAL CORPORATION), Orissa, 751013",
                        "locality": "XIMB Square",
                        "areaName": "Jayadev Vihar",
                        "costForTwo": "40000",
                        "costForTwoMessage": "₹400 FOR TWO",
                        "cuisines": [
                          "Pastas"
                        ],
                        "avgRating": 4.1,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.1",
                        "totalRatingsString": "56",
                        "sla": {
                          "deliveryTime": 27,
                          "minDeliveryTime": 25,
                          "maxDeliveryTime": 30,
                          "lastMileTravel": 1.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "25-30 MINS",
                          "lastMileTravelString": "1.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "861589",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "861589",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "688306",
                        "name": "Pizza Box",
                        "city": "57",
                        "slugs": {
                          "restaurant": "pizza-box-patia-patia",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "eff8cf705f9d8da14961091d88998168",
                        "address": "CHP-2,LANE-2,KANAN VIHAR PH-1,PATIA,BHUBANESWAR,751017",
                        "locality": "Chandrasekharpur",
                        "areaName": "Chandrashekarpur",
                        "costForTwo": "20000",
                        "costForTwoMessage": "₹200 FOR TWO",
                        "cuisines": [
                          "Pizzas"
                        ],
                        "avgRating": 4.5,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.5",
                        "totalRatingsString": "1.7K+",
                        "sla": {
                          "deliveryTime": 43,
                          "minDeliveryTime": 40,
                          "maxDeliveryTime": 45,
                          "lastMileTravel": 5,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "40-45 MINS",
                          "lastMileTravelString": "5.0 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "50% OFF",
                          "discountTag": "FLAT DEAL",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "688306",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "688306",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "491428",
                        "name": "Divine Inn",
                        "city": "57",
                        "slugs": {
                          "restaurant": "divine-inn-old-bbsr-old-bbsr",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "wjbrf7xup9qndfa44zww",
                        "address": "Plot No. 31/2054/3180(Beside Gangotri Farm House Gate No. 3)Gangotri Nagar Lane No. Sisupalagada Bhubanes Dist:- Khordha  Odisha - 751002",
                        "locality": "Samantarapur",
                        "areaName": "Old BBSR",
                        "costForTwo": "25000",
                        "costForTwoMessage": "₹250 FOR TWO",
                        "cuisines": [
                          "Chinese",
                          "Indian"
                        ],
                        "avgRating": 4.6,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.6",
                        "totalRatingsString": "127",
                        "sla": {
                          "deliveryTime": 53,
                          "minDeliveryTime": 50,
                          "maxDeliveryTime": 55,
                          "lastMileTravel": 10.3,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "50-55 MINS",
                          "lastMileTravelString": "10.3 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "aggregatedDiscountInfo": {
                          "visible": true
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV2": {
                          "visible": true
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "--"
                          }
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "491428",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "restaurant_id": "491428",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false",
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                      "info": {
                        "id": "250916",
                        "name": "Budapest Bake Inn",
                        "city": "57",
                        "slugs": {
                          "restaurant": "budapest-bake--in-khandagiri-khandagiri",
                          "city": "bhubaneswar"
                        },
                        "cloudinaryImageId": "dyb9rmkuadqnhaxwsuoj",
                        "address": "Plot No-1176,Ground Floor,Jagamara,Khandagiri, District - Bhubaneswar Municipal Corporation, State - Orissa - 751030",
                        "locality": "Jagmohan Nagar",
                        "areaName": "Khandagiri",
                        "costForTwo": "25000",
                        "costForTwoMessage": "₹250 FOR TWO",
                        "cuisines": [
                          "Bakery",
                          "Beverages",
                          "Desserts"
                        ],
                        "avgRating": 4.7,
                        "feeDetails": {
                          
                        },
                        "avgRatingString": "4.7",
                        "totalRatingsString": "1.6K+",
                        "sla": {
                          "deliveryTime": 50,
                          "minDeliveryTime": 45,
                          "maxDeliveryTime": 50,
                          "lastMileTravel": 8.8,
                          "serviceability": "SERVICEABLE",
                          "rainMode": "RAIN_MODE_NONE",
                          "slaString": "45-50 MINS",
                          "lastMileTravelString": "8.8 km",
                          "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                          "opened": true,
                          "restaurantClosedMeta": {
                            
                          }
                        },
                        "badges": {
                          
                        },
                        "aggregatedDiscountInfoV3": {
                          "header": "10% OFF",
                          "subHeader": "ABOVE ₹500",
                          "discountTag": "FLAT DEAL",
                          "logoCtx": {
                            "text": "BENEFITS"
                          }
                        },
                        "ratingSlab": "RATING_SLAB_5",
                        "orderabilityCommunication": {
                          "title": {
                            
                          },
                          "subTitle": {
                            
                          },
                          "message": {
                            
                          },
                          "customIcon": {
                            
                          },
                          "commsStyling": {
                            
                          }
                        },
                        "cartOrderabilityNudgeBanner": {
                          "parameters": {
                            
                          },
                          "presentation": {
                            
                          }
                        },
                        "externalRatings": {
                          "aggregatedRating": {
                            "rating": "4.6",
                            "ratingCount": "533"
                          },
                          "source": "GOOGLE",
                          "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                        },
                        "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY",
                        "featuredSectionInfo": {
                          "sectionTitle": "More"
                        }
                      },
                      "analytics": {
                        "screenName": "explore",
                        "context": "{\"tid\":\"37fae3cf-4265-fc97-72ee-03258d0392f7\",\"grid\":\"881b7e2b-e56f-4ae2-94d0-9b956de348a0\",\"queryUniqueId\":\"c4e68721-e7d7-b95a-1aff-84b1bccb6bb9\",\"query\":\"Top Rated Pizza Joints In Bhubaneswar\"}",
                        "objectValue": "250916",
                        "impressionObjectName": "impression-restaurant",
                        "clickObjectName": "click-restaurant"
                      },
                      "ctaWithParams": {
                        "link": "swiggy://menu",
                        "type": "DEEPLINK",
                        "params": {
                          "sourceRequestId": "fcb0e8553d7e65560a86948b8017890d",
                          "restaurant_id": "250916",
                          "query": "Top Rated Pizza Joints In Bhubaneswar",
                          "sourceSessionId": "htw9e710-ac0a-46ab-8e1f-e92064556fb3",
                          "source": "SEARCH",
                          "isSld": "false"
                        }
                      }
                    }
                  }
                }
]

export default resData;